import { render, staticRenderFns } from "./Candidates.vue?vue&type=template&id=ef3b7c7a&scoped=true"
import script from "./Candidates.vue?vue&type=script&lang=ts"
export * from "./Candidates.vue?vue&type=script&lang=ts"
import style0 from "./Candidates.vue?vue&type=style&index=0&id=ef3b7c7a&prod&lang=scss&scoped=true"
import style1 from "./Candidates.vue?vue&type=style&index=1&id=ef3b7c7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef3b7c7a",
  null
  
)

export default component.exports